import Image from "react-image-enlarger";
import React from 'react';
import {useLocation} from 'react-router-dom';
import {works} from './workconfig';

function SingleSource({ src }) {
    const [zoomed, setZoomed] = React.useState(false);
  
    return (
        <Image
          style={{ width: "100%"}}
          zoomed={zoomed}
          src={src}
          onClick={() => setZoomed(true)}
          onRequestClose={() => setZoomed(false)}
        />
    );
}

function WorkItems() {
    const location = useLocation();
    const pathname = location.pathname.replace("/","");
    const currentWorkItemIndex = works.findIndex(workitem=>workitem.Assets===decodeURI(pathname).toLowerCase());
    let workPrevious,workPreviousTitle,workNext,workNextTitle,contextItems,title,assets;
    title = works[currentWorkItemIndex].Title.split("|")[0];
    assets = works[currentWorkItemIndex].Assets;
    contextItems = works[currentWorkItemIndex].ContextItems;

    if(currentWorkItemIndex===0){
        workPrevious=works[works.length-1].Assets;
        workPreviousTitle=works[works.length-1].Title.split("|")[0];
    }
    else{
        workPrevious=works[currentWorkItemIndex-1].Assets;
        workPreviousTitle=works[currentWorkItemIndex-1].Title.split("|")[0];
    }

    if(currentWorkItemIndex===works.length-1){
        workNext=works[0].Assets;
        workNextTitle=works[0].Title.split("|")[0];
    }
    else{
        workNext=works[currentWorkItemIndex+1].Assets;
        workNextTitle=works[currentWorkItemIndex+1].Title.split("|")[0];
    }

    return {workPrevious:workPrevious,workPreviousTitle:workPreviousTitle,workNext:workNext,workNextTitle:workNextTitle,contextItems:contextItems,title:title,assets:assets}
}

export {SingleSource,WorkItems}